import requester from '@zg-rentals/particles-js-requester';
import requestWrapper from '@common/utils/requestWrapper';
import StringConstants from '@common/constants/StringConstants';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const GET = StringConstants.API.VERBS.GET;
const POST = StringConstants.API.VERBS.POST;

const apiBase = __BROWSER__ ? 'rental-manager/payments/proxy/rental-manager-api' : '/rental-manager-api';

const client = requester({
  proxyPath: apiBase,
  api: typeof window === 'undefined' ? process.env.RENTAL_MANAGER_API : '',
  logger: getGlobalLogger('requester'),
});

const api = {
  users: {
    signUrl(url, params) {
      const endpoint = `/api/v1/multibrandSupport/googleMaps`;
      const { brandName } = params;

      return requestWrapper(client, POST, endpoint, {
        body: { url },
        params: { brandName },
      });
    },
    getUser({ pageWithSensitiveInformation = false } = {}) {
      const endpoint = `/api/web/v2/users/get`;

      return requestWrapper(client, GET, endpoint, {
        params: {
          pageWithSensitiveInformation,
        },
      });
    },
    properties: {
      getDetails(propertyId: string) {
        const endpoint = `/api/v1/users/properties/details`;
        return requestWrapper(client, GET, endpoint, {
          params: {
            propertyId,
            includeWebAnalytics: true,
          },
        });
      },
    },
  },
};

export default api;
